module.exports = __webpack_public_path__ + "static/img/news4detail2.fcd51e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news4detail2.jpg
// module id = Ftva
// module chunks = 0